import { render, staticRenderFns } from "./AddScreenFromBrowser.vue?vue&type=template&id=17219844&scoped=true"
import script from "./AddScreenFromBrowser.vue?vue&type=script&lang=js"
export * from "./AddScreenFromBrowser.vue?vue&type=script&lang=js"
import style0 from "./AddScreenFromBrowser.vue?vue&type=style&index=0&id=17219844&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17219844",
  null
  
)

export default component.exports